import react from 'react';
import MyNavbar from "../../../components/student/mynavbar/MyNavbar"; 

// import AboutUs from './screens/Students/About/AboutUs';

import AboutUs from './AboutUs';
import AboutHero from './AboutHero';
import  Pg from './Pg';
import Mission from './Mission';
import Involved from './Involved';
import Footer from "../../../components/student/footer/Footer";
import '../../../assets/css/student/about/AboutUs.css';
const About = () => {
    return(
    <>
     <MyNavbar/> 
     <AboutUs/>
     <AboutHero/>
     <Pg/>
     <Mission/>
     <Involved/>
     <Footer/>
     
    </>
  
  );
};

export default About;